import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout, { Container } from "../components/layout";
import { useUser } from "../config/userProvider";
// import { IoMdArrowRoundBack } from "react-icons/io";
import { BlackButton } from "../components/buttonContainer";
import axios from "axios";
import BackHeader from "../components/backHeader";
import Input from "../components/inputContainer";
import { apiurl } from "../config/config";
import { toast } from "react-toastify";
import { DynamicLoader } from "../components/loader";
import { CountryAndStateData } from "../constants/constant";

const EditStore = () => {
  const { storeId } = useParams();
  const { userData } = useUser();
  const vendorObjId = userData?.vendorDetails?.vendorObjId;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [editStoreLoading, setEditStoreLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [storeMiniId, setStoreMiniId] = useState("");

  const [storeDetails, setStoreDetails] = useState({
    name: "",
    email: "",
    phone: "",
    storeCode: "",

    address: "",
    city: "",
    zipCode: "",
    country: "",
    countryCode: "",
    province: "",
    provinceCode: "",
  });

  console.log("storeDetails", storeDetails);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Handle country selection
    if (name === "country") {
      const selectedCountry = CountryAndStateData[value];
      if (selectedCountry) {
        const { name: countryName, states } = selectedCountry;
        setStates(Object.entries(states)); // Dynamically update states dropdown
        setStoreDetails((prev) => ({
          ...prev,
          country: countryName, // Save country name
          countryCode: value, // Save country code
          province: "", // Clear province name
          provinceCode: "", // Clear province code
        }));
      } else {
        setStates([]); // Clear states dropdown if invalid country is selected
        setStoreDetails((prev) => ({
          ...prev,
          country: value,
          countryCode: "", // Clear country code
          province: "", // Clear province name
          provinceCode: "", // Clear province code
        }));
      }
      return; // Exit early after handling country change
    }

    // Handle province selection
    if (name === "province") {
      const selectedProvince = states.find(([code]) => code === value);
      if (selectedProvince) {
        const [provinceCode, provinceName] = selectedProvince;
        setStoreDetails((prev) => ({
          ...prev,
          province: provinceName, // Save province name
          provinceCode: provinceCode, // Save province code
        }));
      } else {
        setStoreDetails((prev) => ({
          ...prev,
          province: value,
          provinceCode: "", // Clear province code
        }));
      }
      return; // Exit early after handling province change
    }

    setStoreDetails((prev) => ({ ...prev, [name]: value }));
  };

  // const fetchUserData = async () => {
  //   setLoading(true); // Start loading state
  //   try {
  //     const response = await axios.get(
  //       `${apiurl}/admin/v1/store/get/${storeId}`,
  //     );
  //     if (response?.data?.success) {
  //       const storeData = response.data.store;
  //       console.log("STORE DATA:", storeData);

  //       if (storeData) {
  //         setStoreMiniId(storeData?.id);
  //         setStoreDetails({
  //           name: storeData?.storeDetails?.name || "",
  //           email: storeData?.storeDetails?.email || "",
  //           phone: storeData?.storeDetails?.phone || "",
  //           storeCode: storeData?.storeCode || "",

  //           address: storeData?.storeDetails?.addressDetails?.address || "",
  //           city: storeData?.storeDetails?.addressDetails?.city || "",
  //           zipCode: storeData?.storeDetails?.addressDetails?.zip || "",
  //           country: storeData?.storeDetails?.addressDetails?.country || "",
  //           countryCode:
  //             storeData?.storeDetails?.addressDetails?.country_code || "",
  //           province: storeData?.storeDetails?.addressDetails?.province || "",
  //           provinceCode:
  //             storeData?.storeDetails?.addressDetails?.province_code || "",
  //         });
  //       }
  //     } else {
  //       console.warn("Failed to fetch store details. Response not successful.");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching store details:", error);
  //   } finally {
  //     setLoading(false); // Ensure loading state is updated in all cases
  //   }
  // };

  // useEffect(() => {
  //   if (storeId && vendorObjId) {
  //     fetchUserData();
  //   }
  // }, [storeId, vendorObjId, fetchUserData]);

  const fetchUserData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${apiurl}/admin/v1/store/get/${storeId}`,
      );

      if (response?.data?.success) {
        const storeData = response.data.store;

        setStoreMiniId(storeData?.id);

        setStoreDetails({
          name: storeData?.storeDetails?.name || "",
          email: storeData?.storeDetails?.email || "",
          phone: storeData?.storeDetails?.phone || "",
          storeCode: storeData?.storeCode || "",
          address: storeData?.storeDetails?.addressDetails?.address || "",
          city: storeData?.storeDetails?.addressDetails?.city || "",
          zipCode: storeData?.storeDetails?.addressDetails?.zip || "",
          country: storeData?.storeDetails?.addressDetails?.country || "",
          countryCode:
            storeData?.storeDetails?.addressDetails?.country_code || "",
          province: storeData?.storeDetails?.addressDetails?.province || "",
          provinceCode:
            storeData?.storeDetails?.addressDetails?.province_code || "",
        });
      }
    } catch (error) {
      console.error("Error fetching store details:", error);
    } finally {
      setLoading(false);
    }
  }, [storeId]);

  useEffect(() => {
    if (storeId && vendorObjId) {
      fetchUserData();
    }
  }, [storeId, vendorObjId, fetchUserData]);

  console.log("storeId", storeMiniId);
  const handleSubmit = async (e) => {
    setEditStoreLoading(true);
    e.preventDefault();
    const data = {
      id: storeMiniId,
      storeCode: storeDetails.storeCode,
      storeDetails: {
        name: storeDetails?.name,
        email: storeDetails?.email,
        phone: storeDetails?.phone,
        addressDetails: {
          address: storeDetails.address,
          city: storeDetails.city,
          province: storeDetails.province,
          zip: storeDetails.zipCode,
          country: storeDetails.country,
          phone: storeDetails.phone,
          name: storeDetails.name,
          province_code: storeDetails.provinceCode,
          country_code: storeDetails.countryCode,
        },
      },
    };

    try {
      const response = await axios.put(
        `${apiurl}/admin/v1/store/update`,
        data,
        {
          headers: { "Content-Type": "application/json" },
        },
      );

      if (response?.data?.success === true) {
        setEditStoreLoading(false);
        toast.success(
          response?.data?.message
            ? response?.data?.message
            : "Store updated successfully!",
        );
        navigate(`/stores`);
      } else {
        setEditStoreLoading(false);
        toast.error(
          response?.data?.message
            ? response?.data?.message
            : "Failed to update store details.",
        );
      }
    } catch (error) {
      setEditStoreLoading(false);
      console.error("Error updating store:", error);
      toast.error("Something went wrong. Please try again.");
    }
  };

  const handleBack = () => {
    navigate(`/stores/${storeId}`);
  };

  return (
    <Layout>
      <Container>
        {loading === true ? (
          <DynamicLoader maintext="wait" subtext="Fetching Store Data" />
        ) : (
          <div className="flex flex-wrap justify-between w-full h-full">
            <div className="flex flex-col py-2 px-2 md:px-14 w-full h-full">
              <BackHeader leftSide={handleBack} title="Edit Details" />

              <div className="mt-5 md:mt-10">
                <div className="mb-4 flex space-x-4">
                  <Input.Normal
                    label="Store Name"
                    type="text"
                    name="name"
                    value={storeDetails.name}
                    onChange={handleInputChange}
                  />

                  <Input.Normal
                    label="Email"
                    type="email"
                    name="email"
                    value={storeDetails.email}
                    onChange={handleInputChange}
                  />
                </div>

                <div className="mb-4 flex space-x-4">
                  <Input.Normal
                    label="Phone"
                    type="text"
                    name="phone"
                    value={storeDetails.phone}
                    onChange={handleInputChange}
                  />

                  <Input.Normal
                    label="storeCode"
                    type="text"
                    name="storeCode"
                    value={storeDetails.storeCode}
                    onChange={handleInputChange}
                    disabled
                  />
                </div>
                <div className="flex gap-4">
                  <div className="w-full">
                    <label className="text-sm text-slate-500">Address :</label>
                    <input
                      name="address"
                      value={storeDetails.address}
                      placeholder="Enter Address"
                      className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  <div className="w-full">
                    <label className="text-sm text-slate-500">City :</label>
                    <input
                      name="city"
                      value={storeDetails?.city}
                      placeholder="Enter City"
                      className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="w-full">
                    <label className="text-sm text-slate-500">Zip code :</label>
                    <input
                      name="zipCode"
                      value={storeDetails?.zipCode}
                      placeholder="Enter Zip Code"
                      className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="flex gap-4">
                  {/* Country Selection */}
                  <div className="w-full">
                    <label className="text-sm text-slate-500">
                      Select Country :
                    </label>
                    <select
                      name="country"
                      value={storeDetails.countryCode} // Match key with the storeDetails object
                      onChange={handleInputChange}
                      className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                    >
                      <option value="">Select Country</option>
                      {Object.entries(CountryAndStateData).map(
                        ([code, country]) => (
                          <option key={code} value={code}>
                            {country.name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>

                  {/* Province Selection */}
                  <div className="w-full">
                    <label className="text-sm text-slate-500">
                      Select Province :
                    </label>
                    <select
                      name="province"
                      value={storeDetails.provinceCode} // Match key with the storeDetails object
                      onChange={handleInputChange}
                      className="w-full border border-slate-200 focus:outline-none px-4 py-2 my-2 rounded-lg"
                    >
                      <option value="">Select Province</option>
                      {states.map(
                        (
                          [code, name], // Ensure `states` is dynamically updated
                        ) => (
                          <option key={code} value={code}>
                            {name}
                          </option>
                        ),
                      )}
                    </select>
                  </div>
                </div>

                <div className="text-center">
                  <BlackButton
                    handleSubmit={handleSubmit}
                    title="Save Changes"
                    loading={editStoreLoading}
                    loadingTitle={"Saving ..."}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </Container>
    </Layout>
  );
};

export default EditStore;

// export default EditStore;
